/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { SberBindCardStatusQueryResponse, SberBindCardStatusQueryParams, SberBindCardStatus400, SberBindCardStatus401, SberBindCardStatus404, SberBindCardStatus500 } from "../entities/SberBindCardStatus";

function getSberBindCardStatusUrl() {
  const res = { method: 'GET', url: `/api/v1/payments/sber/bind-card` as const }
  return res
}

/**
 * @description Возвращает текущий статус операции привязки карты и последние 4 цифры PAN (если доступны).
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Обязательный query-параметр `txn_id` (ID транзакции привязки карты)
 * @summary Получение статуса привязки банковской карты
 * {@link /api/v1/payments/sber/bind-card}
 */
export async function sberBindCardStatus(params: SberBindCardStatusQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SberBindCardStatusQueryResponse, ResponseErrorConfig<SberBindCardStatus400 | SberBindCardStatus401 | SberBindCardStatus404 | SberBindCardStatus500>, unknown>({ method : "GET", url : getSberBindCardStatusUrl().url.toString(), params, ... requestConfig })
  return res.data
}